export function isImage(fileName) {
  const reg = /(\.jpg|\.jpeg|\.png|\.gif|\.bmp)$/i;
  return reg.test(fileName);
}
// 根据文件名判断是否是视频
export function isVideo(fileName) {
  const reg =
    /(\.mp4|\.avi|\.rmvb|\.wmv|\.flv|\.mov|\.mpg|\.mpeg|\.rm|\.asf|\.3gp|\.mkv|\.3g2|\.h264|\.m4v|\.mj2|\.ogg|\.ogv|\.qt|\.vob|\.webm|\.f4v)$/i;
  return reg.test(fileName);
}
// 根据文件名判断是否是文档
export function isDoc(fileName) {
  const reg = /(\.pdf|\.doc|\.docx|\.ppt|\.pptx|\.xls|\.xlsx)$/i;
  return reg.test(fileName);
}
// 从 electron-store 获取持久化数据
const getPersistedData = async () => {
  try {
    console.log("===55window.electron", window?.electronStore);

    if (window?.electronStore) {
      const isMirror = await window.electronStore.get("live.isMirror");
      const openBeauty = await window.electronStore.get("live.openBeauty");
      const beautyOptions = await window.electronStore.get(
        "live.beautyOptions"
      );
      const showRaiseHand = await window.electronStore.get(
        "live.showRaiseHand"
      );
      const toolbarPosition = await window.electronStore.get(
        "live.toolbarPosition"
      );

      return {
        isMirror: isMirror ?? true, // 默认开启镜像
        openBeauty: openBeauty ?? true, // 默认关闭美颜
        beautyOptions: beautyOptions ?? {
          beauty: 50, // 美颜
          brightness: 50, // 明亮
          ruddy: 50, // 红润
        },
        showRaiseHand: showRaiseHand ?? true, // 默认显示成员举手
        toolbarPosition: toolbarPosition || "left", // 默认工具栏位置
      };
    }
  } catch (error) {
    console.error("Failed to get persisted data:", error);
  }
  return null;
};
// 把所有课件插入白板
const handleInsertCourseware = (whiteBoardService, list) => {
  if (whiteBoardService) {
    list.forEach((item) => {
      const config = {
        url: item.transcode_result,
        title: item.doc_name,
        pages: item.pages || 1,
        resolution: item.resolution,
      };
      if (item.roomFileId) {
        return;
      }
      let id = null;
      if (isVideo(item.doc_name)) {
        id = whiteBoardService.addVideoFile({
          url: item.transcode_result,
          title: item.doc_name,
        });
      } else if (isImage(item.doc_name)) {
        id = whiteBoardService.addImagesFile({
          urls: [item.transcode_result],
          title: item.doc_name,
        });
      } else {
        id = whiteBoardService.addTranscodeFile(config, false);
      }
      if (id) {
        item.roomFileId = id;
      }
    });
  }
  return list;
};
// 初始化状态
const initialState = {
  isReady: false,
  signConfig: {},
  // 摄像设备
  cameraList: [],
  // 当前使用的摄像设备
  currentCameraDevice: {},
  // 麦克风设备
  microphoneList: [],
  // 当前使用的麦克风设备
  currentMicDevice: {},
  // 扬声器设备
  speakerList: [],
  // 当前使用的扬声器设备
  currentSpeakerDevice: {},
  liveService: null,
  imService: null,
  whiteBoardService: null,
  layout: "horizontal", // 默认布局  横向 horizontal  竖向 vertical  演讲者 speaker
  // 房间信息
  roomInfo: {
    isTeacher: false,
    isAssistant: false,
    isDownStage: false,
  },
  // 课程信息
  courseInfo: {},
  // 当前用户状态
  userStatus: {},
  // 设备配置
  deviceSwtich: {
    camera: "on", // 'on' 开启 off 关闭
    microphone: "on",
    speaker: "on",
  },
  // 上台成员信息（包含权限，姓名，头像）
  // members: [],
  // 上台人员的状态
  membersStatus: [],
  // 房间人员的状态（包括上台和下台）
  allMemberStatus: [],
  // 字段：使用 Object 以 user_id 为 key
  // 结构：{ [user_id]: { user_id, name, nickname, ... } }
  // 与 allMemberStatus 同步维护，逐步迁移到新字段
  allMemberStatusMap: {},
  isMirror: true, //默认开启镜像
  openBeauty: true, // 默认关闭美颜
  beautyOptions: {
    beauty: 50, // 美颜
    brightness: 50, // 明亮
    ruddy: 50, // 红润
  },
  showRaiseHand: true, // 默认显示成员举手
  toolbarPosition: "left", // 工具栏位置
  onlineCount: 0, // 学生在线人数
  isDelay: false, // 是否已经拖堂
  myGroupInfo: {}, // 我的群信息
  videoPermission: true, // 视频权限
  audioPermission: true, // 音频权限
  screenPermission: true, // 屏幕权限
  isHXApp: false,
  speakerVolume: 100, // 扬声器音量（控制远端音频的播放音量）
  whiteToolbarKey: null,
  screenShareStatus: "end", // 本地共享状态，start 开始共享 pause 暂停共享 end 结束共享
  remoteScreenShareInfo: {
    status: "end",
  }, // 远程共享信息
  // 屏幕共享之前的一些状态，窗口大小，窗口位置，
  screenSharePreInfo: {
    position: null,
    size: null,
    isAudio: true, // 是否共享系统音频
    isWhiteboard: true, // 是否显示白板工具栏
    currentBoardId: null,
  },
  // 是否展示设置弹窗
  showSet: {
    visible: false,
    initActive: null,
  },
  showCourseSale: false,
  // 是否展示花名册
  showRoster: false,
  // 是否展示共享弹窗---客户端才有
  showScreenShareDialog: false,
  // 快捷消息最大高度
  messageMaxHeight: 0,
  // 是否展示设备检测
  showDeviceCheck: {
    visible: false,
    type: "init", // ‘init’初始化打开 'handle' 操作打开
  },
  // 是否展示请求打开摄像头弹窗
  showOpenVideoDialog: false,
  // 是否展示请求打开麦克分弹窗
  showOpenAudioDialog: false,
  // 对远端人员的拉流状态： pullStreamState = {'idxxxx': {audioPullStream: true, videoPullStream: true}}
  pullStreamState: {},
  // 是否展示修改课中昵称弹窗
  showChangeNickname: {
    visible: false,
    info: {},
  },
  // 工具箱展示
  showToolbox: {
    interval: false,
    timeout: false,
    answerer: false,
  },
  // 白板类型
  whiteboardType: "whiteboard", // whiteboard 白板 courseware 课件
  // 是否展示上传课件弹窗
  showUploadCourseware: false,
  // 共享白板id
  screenShareBoardId: null,
  // 是否是录制页面
  isRecordPage: false,
  // 是否关闭拖堂提示
  isCloseLiveDurationTips: false,
  teacherRoomConfig: {},
  // 人员在线状态
  memberOnlineStatus: {},
  // 网络状态
  networkOnline: true,
  // 报错信息
  errorInfo: {
    errCode: "",
    errMsg: "",
  },
  errorVisible: false,
  showTrophy: {
    visible: false,
    info: {},
  },
};

const state = { ...initialState };

const getters = {
  isShutUp({ userStatus }) {
    return !(userStatus.is_send_msg === 1);
  },
  allShutUp({ roomInfo }) {
    return !(roomInfo.is_send_msg === 1);
  },
  // 将 allMemberStatusMap Object 转为数组（用于需要遍历的场景）
  allMemberStatusMapList({ allMemberStatusMap }) {
    return Object.values(allMemberStatusMap);
  },
  // 根据 user_id 快速获取用户状态
  getMemberStatusFromMap: (state) => (user_id) => {
    return state.allMemberStatusMap[user_id] || null;
  },
};
const mutations = {
  setSpeakerVolume(state, data) {
    state.speakerVolume = data;
  },
  setIsHXApp(state, data) {
    state.isHXApp = data;
  },
  setVideoPermission(state, data) {
    state.videoPermission = data;
  },
  setAudioPermission(state, data) {
    state.audioPermission = data;
  },
  setScreenPermission(state, data) {
    state.screenPermission = data;
  },
  setSignConfig(state, data = {}) {
    state.signConfig = data;
  },
  setIsReady(state, data) {
    state.isReady = data;
  },
  setCameraList(state, data = []) {
    state.cameraList = data;
  },
  setSpeakerList(state, data = []) {
    state.speakerList = data;
  },
  setMicrophoneList(state, data = []) {
    state.microphoneList = data;
  },
  setLiveService(state, data) {
    state.liveService = data;
  },
  setImService(state, data) {
    state.imService = data;
  },
  setWhiteBoardService(state, data) {
    state.whiteBoardService = data;
  },
  setLayout(state, data = "horizontal") {
    state.layout = data;
  },
  setRoomInfo(state, data = {}) {
    const info = { ...state.roomInfo, ...data };
    const list = info.doc || [];
    info.doc = handleInsertCourseware(state.whiteBoardService, list);
    state.roomInfo = info;
  },
  setCurrentCameraDevice(state, data = {}) {
    console.log("new_live_store_setCurrentCameraDevice", data);
    const preDeviceId = state.currentCameraDevice.deviceId;
    const { setFrom, ...rest } = data;
    state.currentCameraDevice = rest || {};
    if (
      state.liveService &&
      data.deviceId !== "disabled" &&
      data.deviceId !== preDeviceId &&
      setFrom !== "callback"
    ) {
      console.log("new_live_store_setCurrentCameraDevice————1", data.deviceId);
      state.liveService.setCurrentCameraDevice({ deviceId: data.deviceId });
    }
  },
  setCurrentMicDevice(state, data = {}) {
    console.log("new_live_store_setCurrentMicDevice", data);
    const { setFrom, ...rest } = data;
    const preDeviceId = state.currentMicDevice.deviceId;
    state.currentMicDevice = rest || {};
    if (
      state.liveService &&
      data.deviceId !== "disabled" &&
      data.deviceId !== preDeviceId &&
      setFrom !== "callback"
    ) {
      state.liveService
        .setCurrentMicDevice({ deviceId: data.deviceId })
        .then(() => {
          const isMute =
            state.userStatus.audio_state !== 1 ||
            state.userStatus.is_up_stage !== 1;
          state.liveService.muteLocalAudio({ mute: isMute });
        });
    }
  },
  setCurrentSpeakerDevice(state, data = {}) {
    console.log("new_live_store_setCurrentSpeakerDevice", data);
    const { setFrom, ...rest } = data;
    const preDeviceId = state.currentSpeakerDevice.deviceId;
    state.currentSpeakerDevice = rest || {};
    if (
      state.liveService &&
      data.deviceId !== "disabled" &&
      data.deviceId !== preDeviceId &&
      setFrom !== "callback"
    ) {
      state.liveService.setCurrentSpeakerDevice({ deviceId: data.deviceId });
    }
  },
  setDeviceSwtich(state, data = {}) {
    state.deviceSwtich = { ...state.deviceSwtich, ...data };
  },
  setUserStatus(state, data = {}) {
    state.userStatus = { ...state.userStatus, ...data };
    if (data.video_state) {
      state.deviceSwtich.camera = data.video_state === 1 ? "on" : "off";
    }
    if (data.audio_state) {
      state.deviceSwtich.microphone = data.audio_state === 1 ? "on" : "off";
    }
  },
  setCourseInfo(state, data = {}) {
    state.courseInfo = { ...state.courseInfo, ...data };
  },
  setIsMirror(state, data) {
    state.isMirror = data;
    // 持久化到 electron-store
    if (window?.electronStore) {
      window.electronStore.set("live.isMirror", data);
    }
  },
  setShowRaiseHand(state, data) {
    state.showRaiseHand = data;
    // 持久化到 electron-store
    if (window?.electronStore) {
      window.electronStore.set("live.showRaiseHand", data);
    }
  },
  setOpenBeauty(state, data) {
    state.openBeauty = data;
    // 持久化到 electron-store
    if (window?.electronStore) {
      window.electronStore.set("live.openBeauty", data);
    }
  },
  setBeautyOptions(state, data = {}) {
    state.beautyOptions = { ...state.beautyOptions, ...data };
    // 持久化到 electron-store
    if (window?.electronStore) {
      window.electronStore.set("live.beautyOptions", state.beautyOptions);
    }
  },
  setToolbarPosition(state, data = "left") {
    state.toolbarPosition = data;
    // 持久化到 electron-store
    if (window?.electronStore) {
      window.electronStore.set("live.toolbarPosition", data);
    }
  },
  setMembersStatus(state, data = []) {
    state.membersStatus = data;
  },
  setAllMemberStatus(state, data = []) {
    state.allMemberStatus = [...data];
  },
  setAllMemberStatusMap(state, data) {
    if (!data) return;

    // 1. 数组：批量合并更新（有则更新，无则添加）
    if (Array.isArray(data)) {
      const newMap = { ...state.allMemberStatusMap };
      data.forEach((member) => {
        if (member && member.user_id) {
          newMap[member.user_id] = {
            ...(newMap[member.user_id] || {}),
            ...member,
          };
        }
      });

      state.allMemberStatusMap = newMap;
      return;
    }

    // 2. 单个对象（有 user_id）：单个用户更新（有则更新，无则添加）
    if (data.user_id) {
      const { user_id, ...status } = data;
      state.allMemberStatusMap = {
        ...state.allMemberStatusMap,
        [user_id]: {
          ...(state.allMemberStatusMap[user_id] || {}),
          user_id,
          ...status,
        },
      };
      return;
    }
  },
  // 删除用户状态
  removeMemberStatusMap(state, user_id) {
    if (user_id && state.allMemberStatusMap[user_id]) {
      // ⭐ 替换整个对象以触发 Vue 响应式更新
      const newMap = { ...state.allMemberStatusMap };
      delete newMap[user_id];
      state.allMemberStatusMap = newMap;
    }
  },
  setOnlineCount(state, data = 0) {
    state.onlineCount = data;
  },
  setIsDelay(state, data) {
    state.isDelay = data;
  },
  setPersistedData(state, data) {
    if (data) {
      Object.keys(data).forEach((key) => {
        if (key === "beautyOptions") {
          state[key] = { ...state[key], ...data[key] };
        } else {
          state[key] = data[key];
        }
      });
    }
    state.isReady = true;
  },
  setWhiteToolbarKey(state, data) {
    state.whiteToolbarKey = data;
  },
  setScreenShareStatus(state, data) {
    state.screenShareStatus = data;
  },
  setRemoteScreenShareInfo(state, data = {}) {
    // const info = {
    //   from: data.from,
    //   status: data.status || "end",
    //   isWhiteboard: data.isWhiteboard,
    // };
    state.remoteScreenShareInfo = {
      ...state.remoteScreenShareInfo,
      ...data,
    };
  },
  setScreenSharePreInfo(state, data = {}) {
    const info = {
      ...state.screenSharePreInfo,
      ...data,
    };
    state.screenSharePreInfo = info;
  },
  setShowSet(state, data) {
    state.showSet = data;
  },
  setShowCourseSale(state, data) {
    state.showCourseSale = data;
  },
  setShowRoster(state, data) {
    state.showRoster = data;
  },
  setShowScreenShareDialog(state, data) {
    state.showScreenShareDialog = data;
  },
  setMessageMaxHeight(state, data) {
    state.messageMaxHeight = data || 0;
  },
  setShowDeviceCheck(state, data) {
    state.showDeviceCheck = {
      ...state.showDeviceCheck,
      ...data,
    };
  },
  setShowOpenVideoDialog(state, data) {
    state.showOpenVideoDialog = data;
  },
  setShowOpenAudioDialog(state, data) {
    state.showOpenAudioDialog = data;
  },
  setPullStreamState(state, data = {}) {
    const pullState = { ...state.pullStreamState };
    if (data && data.userId) {
      const userState = pullState[data.userId] || {};
      pullState[data.userId] = {
        ...userState,
        ...data,
      };
      state.pullStreamState = pullState;
    }
  },
  setShowChangeNickname(state, data) {
    state.showChangeNickname = data;
  },
  setShowToolbox(state, data = {}) {
    state.showToolbox = {
      ...state.showToolbox,
      ...data,
    };
  },
  setWhiteboardType(state, data) {
    if (data) {
      state.whiteboardType = data;
    }
  },
  setShowUploadCourseware(state, data) {
    state.showUploadCourseware = data;
  },
  setScreenShareBoardId(state, data) {
    const localData = {
      roomId: state.roomInfo.id,
      boardId: data,
    };
    localStorage.setItem("lastScreenShareBoardId", JSON.stringify(localData));
    state.screenShareBoardId = data;
  },
  setIsRecordPage(state, data) {
    state.isRecordPage = data;
  },
  setIsCloseLiveDurationTips(state, data) {
    state.isCloseLiveDurationTips = data;
  },
  setTeacherRoomConfig(state, data) {
    state.teacherRoomConfig = {
      ...state.teacherRoomConfig,
      ...data,
    };
  },
  setMemberOnlineStatus(state, data = {}) {
    state.memberOnlineStatus = {
      ...state.memberOnlineStatus,
      ...data,
    };
  },
  setNetworkOnline(state, data) {
    state.networkOnline = data;
  },
  setErrorInfo(state, data = {}) {
    state.errorInfo = {
      ...state.errorInfo,
      ...data,
    };
  },
  setErrorVisible(state, data) {
    state.errorVisible = data;
  },
  setShowTrophy(state, data) {
    state.showTrophy = data;
  },
};

const actions = {
  // 初始化持久化数据
  async initPersistedData({ commit }) {
    try {
      const persistedData = await getPersistedData();
      console.log("===55persistedData", persistedData);

      commit("setPersistedData", persistedData);
    } catch (error) {
      console.error("Failed to initialize persisted data:", error);
      commit("setPersistedData", null);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
